import * as Cookies from 'js-cookie';

class BrightcoveCustomMacros {

	/**
	 * Class constructor.
	 */
	constructor() {
		this.player = videojs.getAllPlayers().length ? videojs.getAllPlayers()[0] : null;
		this.adContainer = document.querySelector('.player__ad-container');

		if (!this.player || !this.adContainer) {
			return;
		}

		this.size = this.adContainer.dataset.size;
		this.sizeArray = this.size.split('x');
		this.ima3Iu = this.adContainer.dataset.ima3Iu;
		this.ciuSzs = this.adContainer.dataset.ciuSzs;
		this.url = encodeURI(window.location.href);
		this.cmsId = this.adContainer.dataset.cmsId;
		this.platform = (window.innerWidth < 768) ? `mweb${vb.environment}` : `web${vb.environment}`;
		this.subscribed = 'f';
		this.playerId = '7TNsdXvoXC';

		if (this.player.ima3) {
			this.player.ima3.adMacroReplacement = url => {
				const playerMode = this.player.isFullscreen() ? 'fs' : (document.body.classList.contains('mini-player') ? 'mp' : 'sp');
				const soundMode = this.getAutoplayCookie() == 1 ? 'muted' : 'unmuted';
				const playbackInitiator = this.getAutoplayCookie() == 1 ? 'ap' : 'uip';

				const cust_params = [
					['platform', this.platform].join('%3D'),
					['sb', this.subscribed].join('%3D'),
					['bcp', this.playerId].join('%3D'),
					['vpm', playerMode].join('%3D'),
					['vsm', soundMode].join('%3D'),
					['vpi', playbackInitiator].join('%3D'),
				].join('%26');

				const parameters = {
					'{sz}': this.size,
					'{iu}': this.ima3Iu,
					'{ciu_szs}': this.ciuSzs,
					'{url}': this.url,
					'{cmsid}': this.cmsId,
					'{vid}': this.player.mediainfo.id,
					'{cust_params}': cust_params
				};

				for (var i in parameters) {
					url = url.split(i).join(encodeURIComponent(parameters[i]));
				}

				return url;
			}
		}
	}

	getAutoplayCookie() {
		const autoplay = Cookies.get('vb_autoplay');

		if (autoplay === undefined) {
			return 1;
		}

		return autoplay;
	}

	getMutedCookie() {
		const muted = Cookies.get('vb_muted');

		if (muted === undefined) {
			return 0;
		}

		return muted;
	}

}

// Create class object
const instance = new BrightcoveCustomMacros();

// Export singleton
export { instance as BrightcoveCustomMacros };
